import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { api } from "../constants/api";
import { baseUrl } from "../constants/url";
import getHeaders from "../utils/getHeaders";
import { time } from "console";
import { Buffer } from "buffer";

const ClubMagazineAdmin = () => {

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [data, setData] = useState([])
  const [noMoreData, setNoMoreData] = useState(false)
  const [form, setForm] = useState({
    name: '',
    pdfFile: null as File | null,
    author: '',
    imageFile: null as File | null,
    date: ''
  });
  
  // Refs for file inputs
  const pdfInputRef = useRef<HTMLInputElement>(null);
  const imageInputRef = useRef<HTMLInputElement>(null);

  // Function to convert file to base64 (from Events.tsx)
  function convertFileToBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.readAsDataURL(file);
  
      reader.onload = () => {
        resolve(reader.result);
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  async function getClubMagazineData() {
    if (page > 0 && itemsPerPage > 0) {
      try {
        setLoading(true)
        setError('')
        const response = await api(true, `/club-magazine?page=${page}&limit=${itemsPerPage}`, 'get');
        setLoading(false)
        
        // Process the data similar to Events component
        var data = response.data.data.map((magazine: any) => {
          let processedMagazine = { ...magazine };
          
          // Process backgroundImage if it exists
          if (magazine.backgroundImage !== null) {
            processedMagazine.backgroundImage = Buffer.from(magazine.backgroundImage.data);
          }
          
          // Process url (PDF) if it exists
          if (magazine.url !== null) {
            processedMagazine.url = Buffer.from(magazine.url.data);
          }
          
          return processedMagazine;
        });
        
        if (Array.isArray(data) && data.length <= 0) {
          setNoMoreData(true)
          if (page > 1) {
            setPage(page - 1)
          }
          return
        }

        if (Array.isArray(data) && data.length < itemsPerPage) {
          setNoMoreData(true)
        }
        setData(data)
      } catch (error: any) {
        console.log(error)
        setLoading(false)
        setError(error?.response?.data?.message || error.message)
        setData([])
      }
    }
  }

  const handlePrev = () => {
    if (page > 1) {
      setNoMoreData(false)
      setPage(page - 1)
    }
  }

  const handleNext = () => {
    if (!noMoreData) {
      setPage(page + 1)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fileType: 'pdf' | 'image') => {
    const files = e.target.files;
    if (files && files[0]) {
      const file = files[0];
      if (fileType === 'pdf') {
        setForm({ ...form, pdfFile: file });
      } else {
        setForm({ ...form, imageFile: file });
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      let payload: any = {
        name: form.name,
        author: form.author,
        time: form.date
      };

      // Convert PDF file to base64 if selected
      if (form.pdfFile) {
        try {
          payload.url = await convertFileToBase64(form.pdfFile);
        } catch (e) {
          console.log("error while uploading PDF");
          setError("Error uploading PDF file");
          setLoading(false);
          return;
        }
      }

      // Convert image file to base64 if selected
      if (form.imageFile) {
        try {
          payload.backgroundImage = await convertFileToBase64(form.imageFile);
        } catch (e) {
          console.log("error while uploading image");
          setError("Error uploading image file");
          setLoading(false);
          return;
        }
      }

      await api(true, '/admin/createClubMagazine', 'post', payload);
      setForm({ name: '', pdfFile: null, author: '', imageFile: null, date: '' });
      // Reset file inputs
      if (pdfInputRef.current) pdfInputRef.current.value = '';
      if (imageInputRef.current) imageInputRef.current.value = '';
      getClubMagazineData();
      alert('Magazine submitted!');
    } catch (err: any) {
      setError(err?.response?.data?.message || err.message || 'Error creating magazine');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('Are you sure you want to delete this magazine?')) return;
    setLoading(true);
    setError('');
    try {
      await api(true, `/admin/deleteMagazine/${id}`, 'delete');
      getClubMagazineData();
    } catch (err: any) {
      setError(err?.response?.data?.message || err.message || 'Error deleting magazine');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClubMagazineData()
  }, [page])

  useEffect(() => {
    // if (localStorage.getItem('lastAuthTimeMillis') &&
    // // @ts-ignore
    // parseInt(localStorage.getItem('lastAuthTimeMillis')) > (new Date().getTime()) - 30*60*1000) {
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberCode'] = localStorage.getItem('MemberCode');
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberId'] = localStorage.getItem('MemberId');
    //    // @ts-ignore
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
    // } else {
    //   window.location.href = '/';
    // }
  }, []);

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">Club Magazines</h2>
      {error && (
        <p style={{ color: 'red' }}>{error}</p>
      )}
      <form className="input-field" onSubmit={handleSubmit} style={{marginBottom: 30, flexDirection: 'column', gap: 0}}>
        <div style={{display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 20}}>
          <div className="input-group">
            <label htmlFor="name">Name :</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} required />
          </div>
          <div className="input-group">
            <label htmlFor="author">Author :</label>
            <input type="text" name="author" value={form.author} onChange={handleChange} required />
          </div>
          <div className="input-group">
            <label htmlFor="date">Date :</label>
            <input type="date" name="date" value={form.date} onChange={handleChange} required />
          </div>
        </div>
        <div style={{display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'center'}}>
          <div className="input-group">
            <label htmlFor="pdfFile">PDF File :</label>
            <input 
              type="file" 
              name="pdfFile" 
              accept=".pdf"
              ref={pdfInputRef}
              style={{ width: '90%' }} 
              onChange={(e) => handleFileChange(e, 'pdf')} 
              required 
            />
          </div>
          <div className="input-group">
            <label htmlFor="imageFile">Image File :</label>
            <input 
              type="file" 
              name="imageFile" 
              accept="image/*"
              ref={imageInputRef}
              style={{ width: '90%' }} 
              onChange={(e) => handleFileChange(e, 'image')} 
              required 
            />
          </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <button className="submitbtn" type="submit" style={{marginTop: 20, height: 45}}>Submit</button>
        </div>
      </form>
      <div className="table-responsive">
      <table className="tbl styled-table" border={1}>
        <thead>
          <tr>
            <th style={{textAlign: 'center', minWidth: 50}}>#</th>
            <th style={{minWidth: 200}}>
              Name
            </th>
            <th style={{textAlign: 'center', minWidth: 200}}>
              URL
            </th>
            <th style={{textAlign: 'center', minWidth: 200}}>
              Image
            </th>
            <th style={{textAlign: 'center', minWidth: 200}}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={3}>
                Loading...
              </td>
            </tr>
          )}
          {!loading && (
            data.map((item: any, index: number) => (
              <tr key={index} style={{ height: 50}}>
                <td style={{textAlign: 'center'}}>
                  {index + 1}
                </td>
                <td>
                  {item.name}
                </td>
                <td>
                  {item.url ? (
                    <a 
                      href={item.url} 
                      download={true}
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: '#007bff' }}
                    >
                      Download PDF
                    </a>
                  ) : (
                    <span style={{ color: '#999' }}>No PDF</span>
                  )}
                </td>
                <td>
                  <div style={{ height: 200, width: 100 }} >
                    {item.backgroundImage !== null ? (
                      <a 
                        href={item.backgroundImage} 
                        download={true}
                        style={{ textDecoration: 'none', color: '#007bff' }}
                      >
                        Download
                      </a>
                    ) : (
                      <span style={{ color: '#999' }}>No image</span>
                    )}
                  </div>
                </td>
                <td className="action-cell">
                  <button className="btn dngr" onClick={() => {
                    if (window.confirm("Are you sure you want to delete this magazine?")) {
                      handleDelete(item.id);
                    }
                  }}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      <div className="page-buttons-container">
        <button disabled={page === 1} onClick={handlePrev} style={{width: 50, padding: 4}}>Prev</button>
        <button disabled={noMoreData} onClick={handleNext} style={{width: 50, padding: 4}}>Next</button>
      </div>
    </div>
  );
};

export default ClubMagazineAdmin;
